import React from "react"
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material"
import { NoteAdd } from "@mui/icons-material";
import { useWorklistQuery } from "../services/verifyService/verify-api";
import { Link } from "react-router-dom"
import { WorklistRequest } from "../services/verifyService/commands";

type ownProps={
    title:string;
    queryParam:string;
    center:string;
    outsourced?:boolean;
    onAction?:() => void;
}

function DashboardCard({title, queryParam, center, outsourced = false, onAction}:ownProps){
    let data = useWorklistQuery(new WorklistRequest(queryParam,center,'NA')).data??[];
    if(queryParam === 'AdecBenefits')
        data = data.filter((item)=> item.isOutsourced === true);
    if(queryParam === 'Benefits')
        data = data.filter((item)=> item.isOutsourced === false);

    // Calculate resolved/unresolved counts for Escalated, VobRequest, and PreQuote
    const showBreakdown = queryParam === 'Escalated' || queryParam === 'VobRequest' || queryParam === 'PreQuote';
    let unresolvedCount = data.length;
    let resolvedCount = 0;

    if (showBreakdown) {
        if (queryParam === 'Escalated') {
            unresolvedCount = data.filter(item => item.hasRequest && !item.isResolved).length;
            resolvedCount = data.filter(item => item.hasRequest && item.isResolved).length;
        } else if (queryParam === 'VobRequest') {
            unresolvedCount = data.filter(item => item.hasVobRequest && !item.isVobResolved).length;
            resolvedCount = data.filter(item => item.hasVobRequest && item.isVobResolved).length;
        } else if (queryParam === 'PreQuote') {
            unresolvedCount = data.filter(item => item.isPreQuote && !item.preQuoteComplete).length;
            resolvedCount = data.filter(item => item.isPreQuote && item.preQuoteComplete).length;
        }
    }

    return <React.Fragment>
                <Card  className='card' sx={{width:'200px', borderRadius:'5pt'}}>
                    <CardHeader className='card-header' title={<Typography color='#62BCBD' variant='body2'>{title}</Typography>}
                        action={onAction ? <IconButton size='small' onClick={onAction} sx={{color: '#9C27B0'}}><NoteAdd fontSize='small'/></IconButton> : undefined}
                    />
                        <CardContent>
                            {showBreakdown ? (
                                <h2 className="center-align" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px'}}>
                                    <Link style={{color:SetDashboardColor(queryParam, unresolvedCount), textDecoration: 'none'}} to={"/Worklist/" + center + '/' + queryParam + '/NA'}>
                                        {unresolvedCount}
                                    </Link>
                                    <span style={{color: '#ccc', fontSize: '30px', fontWeight: '300'}}>|</span>
                                    <Link style={{color:'green', textDecoration: 'none'}} to={"/Worklist/" + center + '/' + queryParam + '/NA'}>
                                        {resolvedCount}
                                    </Link>
                                </h2>
                            ) : (
                                <h2 className="center-align"><Link style={{color:SetDashboardColor(queryParam,data?.length ?? 0)}} to={"/Worklist/" + center + '/' + queryParam + '/NA'}>{data?.length ?? 0}</Link></h2>
                            )}
                        </CardContent>
                </Card>
    </React.Fragment>
}

function SetDashboardColor(param:string, itemCount:number){
    if(param === 'ServiceDate 0-72hrs' && itemCount > 0)
        return 'red';
    if(param === 'ServiceDate 3-7days' && itemCount > 0)
        return 'orange';
    if(param === 'ServiceDate 7-14days' && itemCount > 0)
        return '#DAA520'; // goldenrod
    if(param === 'Low Contribution Margin' && itemCount > 0)
        return 'red';
    if(param === 'Authorizaton Denied' && itemCount > 0)
        return 'red';
    if(param === 'Assistance Needed' && itemCount > 0)
        return 'red';
    if(param === 'Escalated' && itemCount > 0)
        return 'red';
    if(param === 'VobRequest' && itemCount > 0)
        return 'red';
    if(param === 'PreQuote' && itemCount > 0)
        return 'red';
    if(param === 'Implant Variance' && itemCount > 0)
        return 'red';
    return 'green'
}

export {DashboardCard}